import SetPermissionModal from './set-permission-modal.vue'
export default SetPermissionModal
